import { ArrowDownRight } from "lucide-react";

export default function Hero() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-36 md:pt-44 pb-20 md:pb-28 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
        {/* sticker */}
        <div className="hidden md:block absolute -top-6 left-6 md:left-10 -rotate-6 z-10">
          <span className="inline-block bg-[#00A0E4] text-[#000000] font-oswald uppercase text-xs px-3 py-1.5 tracking-widest">
            Post · Production Studio
          </span>
        </div>

        <h1
          data-testid="hero-headline"
          className="font-oswald uppercase leading-[0.95] text-[9vw] md:text-6xl lg:text-7xl xl:text-8xl font-bold tracking-tight max-w-5xl"
        >
          Edits that your <span className="text-[#00A0E4]">audience</span>{" "}
          <span className="font-cormorant italic font-medium normal-case text-white/85 lowercase">can&apos;t</span> stop watching.
        </h1>

        <div className="mt-10 md:mt-12 grid grid-cols-12 gap-6 md:gap-10 items-end">
          <p className="col-span-12 md:col-span-6 lg:col-span-5 text-base md:text-lg text-white/70 leading-relaxed">
            dotMKV Media is a post-production crew editing reaction videos, podcasts and digital content
            for global creators. Clean. Fast. Algorithm-aware.
          </p>

          <div className="col-span-12 md:col-span-6 lg:col-span-7 flex flex-wrap items-center gap-4 md:justify-end">
            <a
              data-testid="hero-cta-primary"
              href="https://cal.com/dotmkv-media-sgkgdp/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-brutal"
            >
              Book a Discovery Call <ArrowDownRight size={18} />
            </a>
            <button data-testid="hero-cta-secondary" onClick={() => go("work")} className="btn-ghost">
              See the Work
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
